import { Title } from '@mantine/core';

import classes from './typography.module.css';

export const TitleOverride = Title.extend({
  classNames: { root: classes.root },
});
